import React from "react";
import { css } from "emotion";
import { boxStyles } from "../styles/theme";

const GenericCard = ({ children, style, onClick, backgroundColor }) => {
  return (
    <div
      style={{ backgroundColor }}
      className={container + ` ${style ? style : ""}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default GenericCard;

const container = css`
  width: 50%;
  background-color: white;
  border-radius: ${boxStyles.borderRadius};
  box-shadow: ${boxStyles.boxShadow};
  display: flex;
  overflow: hidden;
`;
